import Home from "@/Pages/Home";
import Info from "@/Pages/Info";
import Result from "@/Pages/Result";
import Mixture from '@/Pages/Mixture'

import UserLogin from "@/Pages/User/Login";
import UserRegist from "@/Pages/User/Regist";
import UserInfo from "@/Pages/User/Info";
import { Navigate } from "react-router-dom";
import { userInfoField } from "./config";

export default [
  {
    path: "/",
    element: <Navigate to="/home" />,
    showMenu: false,
  },

  {
    path: "/home",
    element: <Home />,
    title: "首页",
  },
  {
    path: "/info/:cas",
    element: <Info />,
    title: "数据页",
    showMenu: false,
  },
  {
    path: "/mixture",
    element: <Mixture />,
    title: "混合物计算",
    showMenu: false,
  },
  {
    path: "/result",
    element: <Result />,
    title: "搜索结果",
    showMenu: false,
  },
  {
    path: "/user",
    title: "用户",
    showMenu: false,
    children: [
      {
        path: "/user",
        element: <Navigate to="/user/login" />,
      },
      {
        path: "/user/login",
        title: "用户登录",
        element: <UserLogin />,
      },
      {
        path: "/user/regist",
        title: "用户注册",
        element: <UserRegist />,
      },
      {
        path: "/user/info",
        title: "用户信息",
        element: <UserInfo />,
      },
    ],
  },

  // {
  //   path: "/home",
  //   title: "首页",
  //   // showMenu: false,
  //   element: <Home />,
  // },

  // {
  //   path: "/createCal",
  //   title: "优化计算",
  //   showMenu: false,
  //   children: [
  //     {
  //       path: "/createCal",
  //       element: <Navigate to="/createCal?k=orgCal" />,
  //       showMenu: false,
  //     },
  //     {
  //       path: "/createCal?k=orgCal",
  //       title: "催化剂结构优化",
  //       element: <MetalloceneCreate />,
  //     },
  //     {
  //       path: "/createCal?k=subCal",
  //       title: "催化剂取代基优化",
  //       element: <MetalloceneCreate />,
  //     },
  //   ]
  //   // element: <MetalloceneCreate />,
  // },

  // {
  //   path: "/createCal?k=orgCal",
  //   title: "催化剂结构优化",
  //   element: <MetalloceneCreate />,
  // },
  // {
  //   path: "/createCal?k=subCal",
  //   title: "催化剂取代基优化",
  //   element: <MetalloceneCreate />,
  // },

  // {
  //   path: "/metallocene",
  //   title: "茂金属催化剂优化计算",
  //   children: [
  //     {
  //       path: "/metallocene",
  //       element: <Navigate to="/metallocene/list" />,
  //       showMenu: false,
  //     },
  //     {
  //       path: "/metallocene/list",
  //       title: "计算任务管理",
  //       element: <MetalloceneList />,
  //     },
  //     {
  //       path: "/metallocene/result/:id",
  //       title: "计算结果",
  //       showMenu: false,
  //       element: <MetalloceneResult />,
  //     },
  //     {
  //       path: "/metallocene/create",
  //       title: "添加计算任务",
  //       element: <MetalloceneCreate />,
  //     },
  //     {
  //       path: "/metallocene/result",
  //       title: "计算结果",
  //       showMenu: false,
  //       element: <MetalloceneResult />,
  //     },
  //   ],
  // },

  // {
  //   path: "/AidedDesign",
  //   title: "茂金属催化剂辅助设计",
  //   children: [
  //     {
  //       path: "/AidedDesign",
  //       element: <Navigate to="/AidedDesign/list" />,
  //       showMenu: false,
  //     },
  //     {
  //       path: "/AidedDesign/list",
  //       element: <AidedDesign_List />,
  //       title: "模型推荐任务管理",
  //     },
  //     {
  //       path: "/AidedDesign/create",
  //       element: <AidedDesign_Create />,
  //       title: "创建模型推荐任务",
  //     },
  //     {
  //       path: "/AidedDesign/show",
  //       element: <AidedDesign_Show />,
  //       title: "预测计算结果展示",
  //       showMenu: false,
  //     },
  //   ],
  // },

  // {
  //   path: "/tests",
  //   title: "实验室智能管理",
  //   children: [
  //     {
  //       path: "/tests",
  //       element: <Navigate to="/tests/list" />,
  //       showMenu: false,
  //     },
  //     {
  //       path: "/tests/list",
  //       element: <Tests_list />,
  //       title: "实验列表",
  //     },
  //     {
  //       path: "/tests/show",
  //       title: "实验结果",
  //       element: <Tests_show />,
  //       showMenu: false,
  //     },
  //     {
  //       path: "/tests/create",
  //       title: "创建实验",
  //       element: <Tests_create />,
  //     },
  //   ],
  // },


  // {
  //   path: "/knowledgeBase/literature/show",
  //   element: <KB_literature_show />,
  //   showMenu: false,
  // },
  // {
  //   path: '/knowledgeBase',
  //   title: '科研知识库',
  //   children: [
  //     {
  //       path: '/knowledgeBase',
  //       element: <Navigate to='/knowledgeBase/structure' />,
  //       showMenu: false,
  //     },
  //     {
  //       path: '/knowledgeBase/structure',
  //       element: <Navigate to='/knowledgeBase/structure/list' />,
  //       showMenu: false,
  //     },
  //     {
  //       path: '/knowledgeBase/structure/list',
  //       element: <KB_structure_list />,
  //       title: '分子结构',
  //     },
  //     {
  //       path: '/knowledgeBase/structure/show',
  //       element: <KB_structure_show />,
  //       showMenu: false,
  //     },
  //     {
  //       path: '/knowledgeBase/literature',
  //       element: <Navigate to='/knowledgeBase/literature/list' />,
  //       showMenu: false,
  //     },
  //     {
  //       path: '/knowledgeBase/literature/list',
  //       element: <KB_literature_list />,
  //       title: '科学文献',
  //     },
  //     {
  //       path: '/knowledgeBase/literature/show',
  //       element: <KB_literature_show />,
  //       showMenu: false,
  //     },
  //   ],
  // },
];
